export const TEMPLATES = {
    germanInformal: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <!--[if gte mso 9]><xml>
   <o:OfficeDocumentSettings>
    <o:AllowPNG/>
    <o:PixelsPerInch>96</o:PixelsPerInch>
   </o:OfficeDocumentSettings>
  </xml><![endif]-->
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
  <meta name="viewport" content="width=device-width">
  <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]-->
  <title></title>

</head>
<body style="margin: 0;">


<!-- Upreach black header line -->

	<table cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>

		<tr>
			<!-- Change the background color in bgcolor="insert color here"
				 In case you have a program with a 'find-and-replace' funcion,
				 just 'find' #141414 and 'replace' it with the desired color code -->
			<td bgcolor="#141414" style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;" valign="top" align="center">
				<a href="https://upreach.com/?utm_source=sharing-email&utm_medium=header&utm_content=upreach-logo" target="_blank" rel="noopener">

					<!-- Change the client logo in src="insert client logo here" -->
					<!-- Or remove the entire <img> tag to remove any logo -->
					<img style="height: 10px; width: 85px; padding-left: 50px;" title="Image" src="https://cloud.upreach.com/assets/upreach-logo-white.png" alt="Image" width="123" align="left" border="0" />
				</a>
			</td>
		</tr>
		<tr>
			<td bgcolor="#141414" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td bgcolor="#141414" style="font-size:28px; line-height: 33px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color: #ffffff; font-weight: bold; text-align: center; padding-top: 0px; padding-bottom: 0px;" valign="top" align="center">
						<p>###TITLE PLACEHOLDER###</p>
					</td>
				</table>
			</td>
		</tr>
		<tr>
			<!-- Change the background color in bgcolor="insert color here"-->
			<td bgcolor="#141414" style="font-size:12px; line-height: 0px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); background-color: #fe8036; text-align: center; padding-top: 4px; padding-bottom: 0px;" valign="top" align="center">
				<!--<img src="https://i.ibb.co/Ky1bkFy/gradient-footer-50.jpg" width="300px">-->
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td bgcolor="#f5f7f8" style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>
	</tbody>
	</table>

<!-- end Upreach black header line -->
    
<!-- Customer text -->

    <table cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">

				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td bgcolor="#f5f7f8" style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#000000; text-align: center; padding-bottom: 25px;" valign="top" align="center">
						<p>###TEXT PLACEHOLDER###</p>
					</td>
				</table>
			</td>
			<!-- Change the background color in bgcolor="insert color here"-->
		</tr>
	</tbody>
	</table>
    
<!-- End of customer text -->

<!-- Customer content goes here -->
<!-- End of customer content -->



<!-- Photo from photobooth -->
	<!-- wrapper -->
	<table cellspacing="0" cellpadding="0" border="0" width="100%" bgcolor="#f5f7f8" style="padding-left: 10px; padding-right: 10px;">
	<tbody><tr><td valign="top" align="center">

	<!--[if mso]>
	<table cellspacing="0" cellpadding="0" border="0" width="500">
	<![endif]-->
	<!--[if !mso]><!-->
	<table cellspacing="0" cellpadding="0" border="0" width="500" style="width: 100%; max-width: 500px;">
	<!--<![endif]-->
	<tbody><tr><td valign="top" align="center">

	<!--[if mso]>
	<table cellspacing="0" cellpadding="0" border="0" width="500">
	<![endif]-->
	<!--[if !mso]><!-->
	<table cellspacing="0" cellpadding="0" border="0" width="500" style="width: 100%; max-width: 500px;">
	<!--<![endif]-->
	<tbody>
        <tr>
            <td style="font-size:12px; text-align: center" colspan="2">(Vorschau - bitte ans Ende der E-Mail scrollen, um den Video-Anhang herunterzuladen.)</td>
        </tr>
		<tr>
			<div style="max-height:0;max-width:0;overflow: visible;">
				<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 10px; padding-bottom: 10px;" valign="top" align="center">
							<!--[if mso]>
							<printimg style="height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;" title="Image" src="cid:print_image" alt="Image" width="dynamic_width_mso" align="top" border="0"/>
							<shareimg style="height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;" title="Image" src="cid:gif_image" alt="Image" width="dynamic_width_mso" align="center" border="0"/>
							<![endif]-->

							<!--[if !mso]><!-->
							<printimg style="height: 11px; width: dynamic_width; height: auto; display: inline-block;" title="Image" src="cid:print_image" alt="Image" width="dynamic_width" align="top" border="0" />
							<shareimg style="height: 11px; width: dynamic_width; height: auto; display: inline-block;" title="Image" src="cid:gif_image" alt="Image" width="dynamic_width" align="top" border="0" />
							<!--<![endif]-->
				</td>
			</div>
		</tr>
	</tbody>
	</table>

	<!-- closing wrapper -->
		</td></tr></tbody>
	</table>
	</td></tr></tbody>
	</table>

<!-- End Photo from photobooth -->


<!-- Upreach general links -->
	<table bgcolor="#f5f7f8" cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>
		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						<strong>So teilst du dein Bild&nbsp;in Social Media:</strong>
					</td>
				</table>
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						1. Speichere dein Foto&nbsp;lokal auf deinem Ger&auml;t ab
					</td>
				</table>
			</td>
		</tr>
		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						(am Handy: auf das Bild tippen und gedr&uuml;ckt halten)
					</td>
				</table>
			</td>
		</tr>

		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						2. &Ouml;ffne Instagram&#44; WhatsApp&#44; Facebook
					</td>
				</table>
			</td>
		</tr>
		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						oder eine andere App deiner Wahl
					</td>
				</table>
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						3. Lade dein Bild hoch - viel Spa&szlig;!
					</td>
				</table>
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td align="center" valign="middle" width="300" height="40" style="padding: 5px; line-height: 20px;">
						<a href="https://www.instagram.com/" target="_blank" style="background-color: #fe8036ec; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; padding: 10px 40px 10px 40px; margin: 0; font-family:sans-serif; font-size:12px; font-weight:bold; color: #ffffff; width: 202px; line-height: 24px; text-decoration: none;">
							Jetzt Instagram öffnen
						</a>
					</td>
				</table>
			</td>
        </tr>



		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
					</td>
				</table>
			</td>
		</tr>


		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center" width="300">
					</td>
				</table>
			</td>
		</tr>

	</tbody>
	</table>
<!-- End Upreach general links -->






<!-- Customer logo before footer upreach logo -->
	<table bgcolor="#f5f7f8" cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>
	<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center" width="300">

			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>
	</tbody>
	</table>
<!-- end Customer logo before footer upreach logo -->


<!-- Upreach black footer line -->

	<table bgcolor="#f5f7f8" cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>



		<tr>
			<!-- Change the background color in bgcolor="insert color here"-->
			<td bgcolor="#141414" style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;" valign="top" align="center">

				<!-- Change the client logo in src="insert client logo here" -->
				<!-- Or remove the entire <img> tag to remove any logo -->
                <a href="https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-logo" target="_blank" rel="noopener">
                    <img style="height: 17.6px; width: auto; padding-bottom: 10px; padding-top: 10px;" title="Image" src="https://cloud.upreach.com/assets/upreach-logo-white.png" alt="Image" width="94" align="center" border="0" />
                </a> 
                <p style="color: #ffffff; text-align: center; "><span style="font-style: italic;">Copyright © 2020 UpReach GmbH &amp; Co. KG</span><br>
                Borsigstr. 27<br>
                    10115 Berlin-Mitte<br>
                    <br>
                    <a href="mailto:mail@upreach.com" style="color: #ffffff; text-decoration:underline;" target="_blank" rel="noopener">mail@upreach.com</a> | <a style="text-decoration: underline; color: #ffffff;" href="https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-url">UpReach.com</a>
                </p>
			</td>
		</tr>
		
	</tbody>
	</table>
									
<!-- end UpReach black footer line -->

<!-- UpReach gradient: background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); -->


</body>
</html>`,
    germanFormal: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <!--[if gte mso 9]><xml>
   <o:OfficeDocumentSettings>
    <o:AllowPNG/>
    <o:PixelsPerInch>96</o:PixelsPerInch>
   </o:OfficeDocumentSettings>
  </xml><![endif]-->
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
  <meta name="viewport" content="width=device-width">
  <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]-->
  <title></title>

</head>
<body style="margin: 0;">


<!-- Upreach black header line -->

	<table cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>

		<tr>
			<!-- Change the background color in bgcolor="insert color here"
				 In case you have a program with a 'find-and-replace' funcion,
				 just 'find' #141414 and 'replace' it with the desired color code -->
			<td bgcolor="#141414" style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;" valign="top" align="center">
				<a href="https://upreach.com/?utm_source=sharing-email&utm_medium=header&utm_content=upreach-logo" target="_blank" rel="noopener">

					<!-- Change the client logo in src="insert client logo here" -->
					<!-- Or remove the entire <img> tag to remove any logo -->
					<img style="height: 10px; width: 85px; padding-left: 50px;" title="Image" src="https://cloud.upreach.com/assets/upreach-logo-white.png" alt="Image" width="94" align="left" border="0" />
				</a>
			</td>
		</tr>
		<tr>
			<!-- Change the background color in bgcolor="insert color here"-->
			<td bgcolor="#141414" style="font-size:28px; line-height: 33px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color: #ffffff; font-weight: bold; text-align: center; padding-top: 0px; padding-bottom: 0px;" valign="top" align="center">
				<p>###TITLE PLACEHOLDER###</p>
			</td>
		</tr>
		<tr>
			<!-- Change the background color in bgcolor="insert color here"-->
			<td bgcolor="#141414" style="font-size:12px; line-height: 0px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); background-color: #fe8036; text-align: center; padding-top: 4px; padding-bottom: 0px;" valign="top" align="center">
				<!--<img src="https://i.ibb.co/Ky1bkFy/gradient-footer-50.jpg" width="300px">-->
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td bgcolor="#f5f7f8" style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>
	</tbody>
	</table>

<!-- end Upreach black header line -->

<!-- Customer text -->

    <table cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">

				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td bgcolor="#f5f7f8" style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#000000; text-align: center; padding-bottom: 25px;" valign="top" align="center">
						<p>###TEXT PLACEHOLDER###</p>
					</td>
				</table>
			</td>
			<!-- Change the background color in bgcolor="insert color here"-->
		</tr>
	</tbody>
	</table>
    
<!-- End of customer text -->

<!-- Customer content goes here -->
<!-- End of customer content -->



<!-- Photo from photobooth -->
	<!-- wrapper -->
	<table cellspacing="0" cellpadding="0" border="0" width="100%" bgcolor="#f5f7f8" style="padding-left: 10px; padding-right: 10px;">
	<tbody><tr><td valign="top" align="center">

	<!--[if mso]>
	<table cellspacing="0" cellpadding="0" border="0" width="500">
	<![endif]-->
	<!--[if !mso]><!-->
	<table cellspacing="0" cellpadding="0" border="0" width="500" style="width: 100%; max-width: 500px;">
	<!--<![endif]-->
	<tbody><tr><td valign="top" align="center">

	<!--[if mso]>
	<table cellspacing="0" cellpadding="0" border="0" width="500">
	<![endif]-->
	<!--[if !mso]><!-->
	<table cellspacing="0" cellpadding="0" border="0" width="500" style="width: 100%; max-width: 500px;">
	<!--<![endif]-->
	<tbody>
        <tr>
            <td style="font-size:12px; text-align: center" colspan="2">(Vorschau - bitte ans Ende der E-Mail scrollen, um den Video-Anhang herunterzuladen.)</td>
        </tr>
		<tr>
			<div style="max-height:0;max-width:0;overflow: visible;">
				<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 10px; padding-bottom: 10px;" valign="top" align="center">
							<!--[if mso]>
							<printimg style="height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;" title="Image" src="cid:print_image" alt="Image" width="dynamic_width_mso" align="top" border="0"/>
							<shareimg style="height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;" title="Image" src="cid:gif_image" alt="Image" width="dynamic_width_mso" align="center" border="0"/>
							<![endif]-->

							<!--[if !mso]><!-->
							<printimg style="height: 11px; width: dynamic_width; height: auto; display: inline-block;" title="Image" src="cid:print_image" alt="Image" width="dynamic_width" align="top" border="0" />
							<shareimg style="height: 11px; width: dynamic_width; height: auto; display: inline-block;" title="Image" src="cid:gif_image" alt="Image" width="dynamic_width" align="top" border="0" />
							<!--<![endif]-->
				</td>
			</div>
		</tr>
	</tbody>
	</table>

	<!-- closing wrapper -->
		</td></tr></tbody>
	</table>
	</td></tr></tbody>
	</table>

<!-- End Photo from photobooth -->


<!-- Upreach general links -->
	<table bgcolor="#f5f7f8" cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>
		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
				<strong>So teilen Sie Ihr Bild in Social Media:</strong>
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
				1. Speichern Sie Ihr Foto&nbsp;lokal auf Ihrem Ger&auml;t ab
			</td>
		</tr>
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
				(am Handy: auf das Bild tippen und gedr&uuml;ckt halten)
			</td>
		</tr>

		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
				2. &Ouml;ffnen Sie Instagram&#44; WhatsApp&#44; Facebook
			</td>
		</tr>
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
				oder eine andere App Ihrer Wahl
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
				3. Laden Sie Ihr Bild hoch - viel Spaß
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td align="center" valign="middle" width="300" height="40" style="padding: 5px; line-height: 20px;">
				<a href="https://www.instagram.com/" target="_blank" style="background-color: #fe8036ec; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; padding: 10px 40px 10px 40px; margin: 0; font-family:sans-serif; font-size:12px; font-weight:bold; color: #ffffff; width: 202px; line-height: 24px; text-decoration: none;">
					Jetzt Instagram öffnen
				</a>
			</td>
        </tr>


	</tbody>
	</table>
<!-- End Upreach general links -->






<!-- Customer logo before footer upreach logo -->
	<table bgcolor="#f5f7f8" cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>
	<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center" width="300">

			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>
	</tbody>
	</table>
<!-- end Customer logo before footer upreach logo -->


<!-- Upreach black footer line -->

	<table bgcolor="#f5f7f8" cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>



		<tr>
			<!-- Change the background color in bgcolor="insert color here"-->
			<td bgcolor="#141414" style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;" valign="top" align="center">

				<!-- Change the client logo in src="insert client logo here" -->
				<!-- Or remove the entire <img> tag to remove any logo -->
                <a href="https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-logo" target="_blank" rel="noopener">
                    <img style="height: 17.6px; width: auto; padding-bottom: 10px; padding-top: 10px;" title="Image" src="https://cloud.upreach.com/assets/upreach-logo-white.png" alt="Image" width="94" align="center" border="0" />
                </a> 
                <p style="color: #ffffff; text-align: center; "><span style="font-style: italic;">Copyright © 2020 UpReach GmbH &amp; Co. KG</span><br>
                Borsigstr. 27<br>
                    10115 Berlin-Mitte<br>
                    <br>
                    <a href="mailto:mail@upreach.com" style="color: #ffffff; text-decoration:underline;" target="_blank" rel="noopener">mail@upreach.com</a> | <a style="text-decoration: underline; color: #ffffff;" href="https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-url">UpReach.com</a>
                </p>
			</td>
		</tr>
		
	</tbody>
	</table>
									
<!-- end UpReach black footer line -->

<!-- UpReach gradient: background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); -->


</body>
</html>`,
    english: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
  <!--[if gte mso 9]><xml>
   <o:OfficeDocumentSettings>
    <o:AllowPNG/>
    <o:PixelsPerInch>96</o:PixelsPerInch>
   </o:OfficeDocumentSettings>
  </xml><![endif]-->
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
  <meta name="viewport" content="width=device-width">
  <!--[if !mso]><!--><meta http-equiv="X-UA-Compatible" content="IE=edge"><!--<![endif]-->
  <title></title>

</head>
<body style="margin: 0;">


<!-- Upreach black header line -->

	<table cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>

		<tr>
			<!-- Change the background color in bgcolor="insert color here"
				 In case you have a program with a 'find-and-replace' funcion,
				 just 'find' #141414 and 'replace' it with the desired color code -->
			<td bgcolor="#141414" style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;" valign="top" align="center">
				<a href="https://upreach.com/?utm_source=sharing-email&utm_medium=header&utm_content=upreach-logo" target="_blank" rel="noopener">

					<!-- Change the client logo in src="insert client logo here" -->
					<!-- Or remove the entire <img> tag to remove any logo -->
					<img style="height: 10px; width: 85px; padding-left: 50px;" title="Image" src="https://cloud.upreach.com/assets/upreach-logo-white.png" alt="Image" width="123" align="left" border="0" />
				</a>
			</td>
		</tr>
		<tr>
			<td bgcolor="#141414" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td bgcolor="#141414" style="font-size:28px; line-height: 33px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color: #ffffff; font-weight: bold; text-align: center; padding-top: 0px; padding-bottom: 0px;" valign="top" align="center">
						<p>###TITLE PLACEHOLDER###</p>
					</td>
				</table>
			</td>
		</tr>
		<tr>
			<!-- Change the background color in bgcolor="insert color here"-->
			<td bgcolor="#141414" style="font-size:12px; line-height: 0px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); background-color: #fe8036; text-align: center; padding-top: 4px; padding-bottom: 0px;" valign="top" align="center">
				<!--<img src="https://i.ibb.co/Ky1bkFy/gradient-footer-50.jpg" width="300px">-->
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td bgcolor="#f5f7f8" style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>
	</tbody>
	</table>

<!-- end Upreach black header line -->

<!-- Customer text -->

    <table cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">

				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td bgcolor="#f5f7f8" style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#000000; text-align: center; padding-bottom: 25px;" valign="top" align="center">
						<p>###TEXT PLACEHOLDER###</p>
					</td>
				</table>
			</td>
			<!-- Change the background color in bgcolor="insert color here"-->
		</tr>
	</tbody>
	</table>
    
<!-- End of customer text -->

<!-- Customer content goes here -->
<!-- End of customer content -->



<!-- Photo from photobooth -->
	<!-- wrapper -->
	<table cellspacing="0" cellpadding="0" border="0" width="100%" bgcolor="#f5f7f8" style="padding-left: 10px; padding-right: 10px;">
	<tbody><tr><td valign="top" align="center">

	<!--[if mso]>
	<table cellspacing="0" cellpadding="0" border="0" width="500">
	<![endif]-->
	<!--[if !mso]><!-->
	<table cellspacing="0" cellpadding="0" border="0" width="500" style="width: 100%; max-width: 500px;">
	<!--<![endif]-->
	<tbody><tr><td valign="top" align="center">

	<!--[if mso]>
	<table cellspacing="0" cellpadding="0" border="0" width="500">
	<![endif]-->
	<!--[if !mso]><!-->
	<table cellspacing="0" cellpadding="0" border="0" width="500" style="width: 100%; max-width: 500px;">
	<!--<![endif]-->
	<tbody>
        <tr>
            <td style="font-size:12px; text-align: center" colspan="2">(Preview - please scroll down to the bottom of the email to download the video attachment.)</td>
        </tr>
		<tr>
			<div style="max-height:0;max-width:0;overflow: visible;">
				<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 10px; padding-bottom: 10px;" valign="top" align="center">
							<!--[if mso]>
							<printimg style="height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;" title="Image" src="cid:print_image" alt="Image" width="dynamic_width_mso" align="top" border="0"/>
							<shareimg style="height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;" title="Image" src="cid:gif_image" alt="Image" width="dynamic_width_mso" align="center" border="0"/>
							<![endif]-->

							<!--[if !mso]><!-->
							<printimg style="height: 11px; width: dynamic_width; height: auto; display: inline-block;" title="Image" src="cid:print_image" alt="Image" width="dynamic_width" align="top" border="0" />
							<shareimg style="height: 11px; width: dynamic_width; height: auto; display: inline-block;" title="Image" src="cid:gif_image" alt="Image" width="dynamic_width" align="top" border="0" />
							<!--<![endif]-->
				</td>
			</div>
		</tr>
	</tbody>
	</table>

	<!-- closing wrapper -->
		</td></tr></tbody>
	</table>
	</td></tr></tbody>
	</table>

<!-- End Photo from photobooth -->


<!-- Upreach general links -->
	<table bgcolor="#f5f7f8" cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>
		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						<strong>How to share your image on Social Media:</strong>
					</td>
				</table>
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						1. Save your image locally on your device
					</td>
				</table>
			</td>
		</tr>
		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						(on your phone: tap and hold the image)
					</td>
				</table>
			</td>
		</tr>

		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						2. Open Instagram&#44; WhatsApp&#44; Facebook
					</td>
				</table>
			</td>
		</tr>
		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						or another app of your choice
					</td>
				</table>
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
						3. Upload your image - have fun!
					</td>
				</table>
			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td align="center" valign="middle" width="300" height="40" style="padding: 5px; line-height: 20px;">
						<a href="https://www.instagram.com/" target="_blank" style="background-color: #fe8036ec; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; padding: 10px 40px 10px 40px; margin: 0; font-family:sans-serif; font-size:12px; font-weight:bold; color: #ffffff; width: 202px; line-height: 24px; text-decoration: none;">
							Open Instagram now
						</a>
					</td>
				</table>
			</td>
        </tr>


		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#231f20; text-align: center;" valign="top" align="center" width="300">
					</td>
				</table>
			</td>
		</tr>


		<tr>
			<td bgcolor="#f5f7f8" align="center" valign="top">
				<!-- Change the background color in bgcolor="insert color here"-->
				<table style="max-width:500px; border:0; text-align:center;" cellpadding="0" cellspacing="0">
					<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center" width="300">
					</td>
				</table>
			</td>
		</tr>

	</tbody>
	</table>
<!-- End Upreach general links -->






<!-- Customer logo before footer upreach logo -->
	<table bgcolor="#f5f7f8" cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>
	<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>

		<tr>
			<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center" width="300">

			</td>
		</tr>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>
	</tbody>
	</table>
<!-- end Customer logo before footer upreach logo -->


<!-- Upreach black footer line -->

	<table bgcolor="#f5f7f8" cellspacing="0" cellpadding="0" border="0" width="100%">
	<tbody>

		<!-- spacer -->
		<tr>
			<td style="font-size:16px; line-height: 19px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; color:#555555; text-align: center;" valign="top" align="center">&nbsp;</td>
		</tr>



		<tr>
			<!-- Change the background color in bgcolor="insert color here"-->
			<td bgcolor="#141414" style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 20px; padding-bottom: 20px;" valign="top" align="center">

				<!-- Change the client logo in src="insert client logo here" -->
				<!-- Or remove the entire <img> tag to remove any logo -->
                <a href="https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-logo" target="_blank" rel="noopener">
                    <img style="height: 17.6px; width: auto; padding-bottom: 10px; padding-top: 10px;" title="Image" src="https://cloud.upreach.com/assets/upreach-logo-white.png" alt="Image" width="94" align="center" border="0" />
                </a> 
                <p style="color: #ffffff; text-align: center; "><span style="font-style: italic;">Copyright © 2020 UpReach GmbH &amp; Co. KG</span><br>
                Borsigstr. 27<br>
                    10115 Berlin-Mitte<br>
                    <br>
                    <a href="mailto:mail@upreach.com" style="color: #ffffff; text-decoration:underline;" target="_blank" rel="noopener">mail@upreach.com</a> | <a style="text-decoration: underline; color: #ffffff;" href="https://upreach.com/?utm_source=sharing-email&utm_medium=footer&utm_content=upreach-url">UpReach.com</a>
                </p>
			</td>
		</tr>
		
	</tbody>
	</table>
									
<!-- end UpReach black footer line -->

<!-- UpReach gradient: background:linear-gradient(45deg, #fe8036 0%, #ff3150 100%); -->


</body>
</html>`,
    photosPreview: `
    <!-- Photo from photobooth -->
	<!-- wrapper -->
	<table cellspacing="0" cellpadding="0" border="0" width="100%" bgcolor="#f5f7f8" style="padding-left: 10px; padding-right: 10px;">
	<tbody><tr><td valign="top" align="center">

	<!--[if mso]>
	<table cellspacing="0" cellpadding="0" border="0" width="500">
	<![endif]-->
	<!--[if !mso]><!-->
	<table cellspacing="0" cellpadding="0" border="0" width="500" style="width: 100%; max-width: 500px;">
	<!--<![endif]-->
	<tbody><tr><td valign="top" align="center">

	<!--[if mso]>
	<table cellspacing="0" cellpadding="0" border="0" width="500">
	<![endif]-->
	<!--[if !mso]><!-->
	<table cellspacing="0" cellpadding="0" border="0" width="500" style="width: 100%; max-width: 500px;">
	<!--<![endif]-->
	<tbody>
		<tr>
			<div style="max-height:0;max-width:0;overflow: visible;">
				<td style="font-size:12px; line-height: 14px; font-family: sans-serif, Arial, 'Helvetica Neue', Helvetica; text-align: center; padding-top: 10px; padding-bottom: 10px;" valign="top" align="center">
							<!--[if mso]>
							<printimg style="height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;" title="Image" src="cid:print_image" alt="Image" width="dynamic_width_mso" align="top" border="0"/>
							<shareimg style="height: 11px; width: dynamic_width_mso; height: auto; display: inline-block;" title="Image" src="cid:gif_image" alt="Image" width="dynamic_width_mso" align="center" border="0"/>
							<![endif]-->

							<!--[if !mso]><!-->
							<printimg style="height: 11px; width: dynamic_width; height: auto; display: inline-block;" title="Image" src="cid:print_image" alt="Image" width="dynamic_width" align="top" border="0" />
							<shareimg style="height: 11px; width: dynamic_width; height: auto; display: inline-block;" title="Image" src="cid:gif_image" alt="Image" width="dynamic_width" align="top" border="0" />
							<!--<![endif]-->
				</td>
			</div>
		</tr>
	</tbody>
	</table>

	<!-- closing wrapper -->
		</td></tr></tbody>
	</table>
	</td></tr></tbody>
	</table>

<!-- End Photo from photobooth -->`
};


// WEBPACK FOOTER //
// ./sources/services/configuration/email-templates.constant.js